import { styled } from '../../Utilities';
import { PanelBase } from './Panel.base';
import { getStyles } from './Panel.styles';
/**
 * Panel description
 */
export var Panel = styled(PanelBase, getStyles, undefined, {
  scope: 'Panel'
});